import MobileTabSwitcher from "@components/switcher/MobileTabSwitcher";
import { isPaysonicHost } from "src/config/deploymentConfig";
import KybTable from "../../kyb/KybLinks";
import KycApprovalList from "../../Kyc/KycApprovalList";

const MobileKycTabs = () => {
  const isPaysonic = isPaysonicHost();

  const kycTabs = isPaysonic
    ? [
        {
          label: "KYC",
          component: <KycApprovalList />,
        },
      ]
    : [
        {
          label: "KYC",
          component: <KycApprovalList />,
        },
        {
          label: "KYB",
          component: <KybTable />,
        },
      ];

  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100dvh - 56px)" }}
    >
      <div className="h-[56px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 px-4 shrink-0">
        <div className="flex flex-row justify-between items-center w-full">
          <p className="text-text-base text-[16px] font-semibold">KYC</p>
        </div>
      </div>
      <div className="px-3 mt-3 flex min-h-0 flex-1 flex-col">
        <MobileTabSwitcher tabs={kycTabs} />
      </div>
    </div>
  );
};

export default MobileKycTabs;
